"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.polyyeld_xyeld = exports.polyyeld = void 0;
exports.polyyeld = {
    masterchef: '0x2DC11B394BD0f1CC6AC0a269cfe3CC0b333601B4',
};
exports.polyyeld_xyeld = {
    masterchef: '0x54aC698DbA046247B8D081774005A434f03d329D',
};
